import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OnboardingState } from './onboarding.reducers';

// tslint:disable: max-line-length
export const onboardingFeatureStateSelector = createFeatureSelector<OnboardingState>('onboarding');

export const selectAccount = createSelector(onboardingFeatureStateSelector, (state: OnboardingState) => state.createdAccount);
